import { useState, useEffect } from "react";

export const useBackgroundType = () => {
  const [backgroundType, setBackgroundType] = useState("light");

  useEffect(() => {
    const determineBackgroundType = () => {
      // Check for sticky header first (this overrides other detections)
      const stickyHeader = document.querySelector(".sticky-bar.stick");
      if (stickyHeader) {
        // When header is sticky, it typically has a light background
        // Check if it has dark background classes
        const stickyClasses = stickyHeader.className;
        if (
          stickyClasses.includes("bg-black") ||
          stickyClasses.includes("bg-dark")
        ) {
          return "dark";
        }
        // Sticky header with light background
        return "light";
      }

      // Check if we're in a header with dark background classes
      const header = document.querySelector(".header-area");
      if (header) {
        const headerClasses = header.className;

        // Check for transparent or dark headers
        if (
          headerClasses.includes("transparent-bar") ||
          headerClasses.includes("bg-black") ||
          headerClasses.includes("bg-dark")
        ) {
          return "dark";
        }

        // Check for specific header types that typically have dark backgrounds
        // Most header types from hm8 onwards have dark backgrounds
        const headerMatch = headerClasses.match(/header-hm(\d+)/);
        if (headerMatch) {
          const headerNumber = parseInt(headerMatch[1]);
          if (headerNumber >= 8) {
            return "dark";
          }
        }
      }

      // Default to light background
      return "light";
    };

    const updateBackgroundType = () => {
      const newBackgroundType = determineBackgroundType();
      setBackgroundType(newBackgroundType);
    };

    // Initial detection
    updateBackgroundType();

    // Listen for scroll events to detect sticky header changes
    const handleScroll = () => {
      updateBackgroundType();
    };

    window.addEventListener("scroll", handleScroll);

    // Also listen for DOM changes that might affect header classes
    const observer = new MutationObserver(updateBackgroundType);
    const header = document.querySelector(".header-area");
    if (header) {
      observer.observe(header, {
        attributes: true,
        attributeFilter: ["class"],
      });
    }

    return () => {
      window.removeEventListener("scroll", handleScroll);
      observer.disconnect();
    };
  }, []);

  return backgroundType;
};
